import { Clickable } from '@carvana/vdp-components';
import { useContext } from 'react';
import MoreDetailsModalSections from '~/constants/MoreDetailsModalSections';
import ModalContext from '~/contexts/ModalContext';
import { useTileDataContext } from '~/contexts/TileDataContext';
import Pill from './Pill';
import PlugIcon from './PlugIcon';

const EvCreditPill = () => {
  const { setMoreDetailsModalOpen } = useContext(ModalContext);
  const { tileData } = useTileDataContext();

  return (
    <Clickable
      data-analytics-id="open-result-tile-modal"
      data-analytics-attributes={JSON.stringify({
        clickedSource: 'EV credit pill'
      })}
      className="pointer-events-auto"
      onClick={e => {
        e.preventDefault();
        setMoreDetailsModalOpen(true, {
          openTo: MoreDetailsModalSections.EvTax,
          vehicle: tileData
        });
      }}
    >
      <Pill data-qa="ev-credit-pill">
        <div className="flex flex-row gap-4 items-center">
          <PlugIcon />
          EV Credit
        </div>
      </Pill>
    </Clickable>
  );
};

export default EvCreditPill;
